export default __webpack_public_path__ + "static/media/twokitty-screaming.f9bb9dbf.png";